export default "__VITE_PUBLIC_ASSET__6e35ba0a__"